

import { Button } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";

import { useNavigateSearch } from "@/premium/hooks";
import { useEnrollmentContext } from "@/state";

import "./MobileMenuBar.scss";

interface MobileMenuBarProps {
  onMobileMenuToggle: () => void;
  mobileMenuIcon: "menu-bars" | "x";
}

export const MobileMenuBar = ({ mobileMenuIcon, onMobileMenuToggle }: MobileMenuBarProps) => {
  const navigate = useNavigateSearch();

  const experienceData = useEnrollmentContext();
  const theme = experienceData?.theme;

  const handleHomeClick = () => {
    navigate("/");
  };

  return (
    <Shelf className="mobile-menu-bar-container">
      <img
        onClick={handleHomeClick}
        style={{ cursor: "pointer" }}
        data-testid="img-logo"
        height={30}
        src={theme?.logo_desktop}
        alt="Client Logo"
      />
      <Shelf.Spacer />
      <Button appearance="text" icon={mobileMenuIcon} onClick={onMobileMenuToggle}></Button>
    </Shelf>
  );
};
